import { CommonModule, NgClass } from "@angular/common";
import { Component, inject, Input, OnChanges } from "@angular/core";
import { CentralStationConfiguration } from "@domain/project/configurations/monitoring/central-station-configuration";
import { DisplayConfiguration } from "@domain/project/configurations/monitoring/display-configuration";
import { KvmConfiguration } from "@domain/project/configurations/monitoring/kvm-configuration";
import { PatientMonitorConfiguration } from "@domain/project/configurations/monitoring/patient-monitor-configuration";
import { TelemetryConfiguration } from "@domain/project/configurations/monitoring/telemetry-configuration";
import { UtilityConfiguration } from "@domain/project/configurations/monitoring/utility-configuration";
import { FloorplanPlaceholder } from "@domain/project/floorplan/floorplan-placeholder";
import { FloorplanCentralStation } from "@domain/project/floorplan/monitoring/floorplan-central-station";
import { FloorplanDisplay } from "@domain/project/floorplan/monitoring/floorplan-display";
import { FloorplanKvm } from "@domain/project/floorplan/monitoring/floorplan-kvm";
import { FloorplanPatientMonitor } from "@domain/project/floorplan/monitoring/floorplan-patient-monitor";
import { FloorplanTelemetry } from "@domain/project/floorplan/monitoring/floorplan-telemetry";
import { FloorplanUtility } from "@domain/project/floorplan/monitoring/floorplan-utility";
import { MonitoringCategorySection } from "@domain/project/monitoring-product-list/monitoring-category-section";
import { MonitoringConfigProductMap } from "@domain/project/monitoring-product-list/monitoring-config-product-map";
import { ProductListService } from "@domain/project/product-list/product-list.service";
import { TooltipDirective } from "@odx/angular/components/tooltip";

@Component({
  selector: "app-monitoring-product-table",
  imports: [NgClass, TooltipDirective, CommonModule],
  templateUrl: "./monitoring-product-table.component.html",
  styleUrl: "./monitoring-product-table.component.scss",
  standalone: true,
})
export class MonitoringProductTableComponent implements OnChanges {
  private productListService = inject(ProductListService);

  @Input()
  productSection!: MonitoringCategorySection<
    FloorplanPatientMonitor | FloorplanCentralStation | FloorplanTelemetry | FloorplanKvm | FloorplanDisplay | FloorplanUtility,
    FloorplanPlaceholder,
    | PatientMonitorConfiguration
    | CentralStationConfiguration
    | TelemetryConfiguration
    | KvmConfiguration
    | DisplayConfiguration
    | UtilityConfiguration,
    MonitoringConfigProductMap
  >;

  protected placeholderWithProductsCount = 1;
  protected placeholderWithoutProductsCount = 0;
  protected readonly tooltipTextWarningSign: string = $localize`:@@productlist.table.warningSign.tooltip:Produkt enthält abgekündigte Komponenten oder ist Teil einer unvollständigen Konfiguration`;

  ngOnChanges(): void {
    this.placeholderWithoutProductsCount = this.countPlaceholderWithoutId();
  }

  protected countPlaceholderWithoutId() {
    return this.productListService.countUnspecifiedPlaceholders(this.productSection.placeholders);
  }

  protected productBelongsToConfig(
    product:
      FloorplanPatientMonitor | FloorplanCentralStation | FloorplanTelemetry | FloorplanKvm | FloorplanDisplay | FloorplanUtility,
    mapping: MonitoringConfigProductMap,
  ) {
    return product.config.id === mapping.config.id;
  }
}
